export default __webpack_public_path__ + "static/media/step5.5107add0.svg";